import React from "react";
import { toast } from "react-toastify";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    toast.error(error?.message || "An unexpected error occurred.");
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;